/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { FeePool } from '../FeePool'

export class FeePool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(_token: string, overrides?: Overrides): Promise<FeePool> {
    return super.deploy(_token, overrides || {}) as Promise<FeePool>
  }
  getDeployTransaction(
    _token: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_token, overrides || {})
  }
  attach(address: string): FeePool {
    return super.attach(address) as FeePool
  }
  connect(signer: Signer): FeePool__factory {
    return super.connect(signer) as FeePool__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeePool {
    return new Contract(address, _abi, signerOrProvider) as FeePool
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_token',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'sendProfitERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'token',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'
